import { render, staticRenderFns } from "./ehaEdit.vue?vue&type=template&id=a2a2a1b6&"
import script from "./ehaEdit.vue?vue&type=script&lang=js&"
export * from "./ehaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports